<template>
  <div
    class="py-6 px-6 bg-pure-white rounded-xl"
    :style="{ height: '10.25rem', width: '51.25rem' }"
  >
    <div class="mb-5 flex items-center justify-between">
      <BlTextTitle4
        v-if="searchParams['branch']"
        text="Current total active client"
        class="text-slate-900"
      />
      <BlTextTitle4
        v-else
        text="Current total active client and team members"
        class="text-slate-900"
      />
    </div>
    <div v-if="fetchLoading" class="h-16 grid place-content-center">
      <div class="blum-loader-sm"></div>
    </div>
    <div v-else-if="!graphData" class="h-16 grid place-content-center">
      <BlTextBody2 :text="`Data not found.`" />
    </div>
    <div v-else-if="overviewData.length" class="flex gap-7">
      <div
        v-for="item in overviewData"
        :key="item.label"
        class="relative h-16 flex items-center"
        :style="{
          width: `calc((100% - ${(overviewData.length - 1) * 1.75}rem) / ${
            overviewData.length
          })`
        }"
      >
        <BlTooltip
          :tooltip="`<div class='min-w-32'>${item.label}</div>`"
          class="w-full flex flex-col"
        >
          <BlTextTitle3 :text="item.value" class="text-slate-900 self-center" />
          <div class="text-center truncate">
            <BlTextBody2 :text="item.label" class="truncate" />
          </div>
        </BlTooltip>
        <div v-if="item.divider" class="absolute -right-3.5">
          <div class="h-13.5 w-0.5 flex-shrink-0 bg-slate-300"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import BlTextTitle4 from "../../BlTextTitle4.vue";
import BlTextTitle3 from "../../BlTextTitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlTooltip from "../../BlTooltip.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "CenterOverviewCurrentTotal",
  components: {
    BlTextTitle4,
    BlTextTitle3,
    BlTextBody2,
    BlTooltip,
    BlInputButton
  },
  data() {
    return {
      fetchLoading: false,
      graphData: null
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
    searchParams() {
      return this.$route.query || {};
    },
    /*
    {
      "total_active_clients": 19,
      "total_active_therapists": 2,
      "total_active_admins": 2
    }
    */
    overviewData() {
      if (!this.graphData) return [];
      const raw = this.graphData;
      if (!raw) return [];
      let keys = [
        "total_active_clients",
        "total_active_therapists",
        "total_active_admins"
      ];
      let labels = ["Active client", "Active therapist", "Active admin"];
      function rounded(n = 0) {
        const t = n.toString();
        return t.includes(".") ? n.toFixed(1) : n;
      }
      if (this.searchParams["branch"]) {
        return [{ label: labels[0], value: rounded(raw[keys[0]] || 0) }];
      }
      return keys.map((key, idx) => ({
        label: labels[idx],
        value: rounded(raw[key] || 0),
        divider: idx !== keys.length - 1
      }));
    }
  },
  mounted() {
    this.fetchGraph();
  },
  methods: {
    ...mapActions(["actionGet"]),
    fetchGraph() {
      let params = ``;
      if (this.searchParams["branch"]) {
        params = `?branch_id=${this.searchParams["branch"]}`;
      }
      const data = {
        url: `/api/v1/analytics/user_overview${params}`
      };
      this.fetchLoading = true;
      this.graphData = null;
      this.actionGet(data).then(({ success, data }) => {
        this.fetchLoading = false;
        if (!success) return;
        this.graphData = data;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/analytics/mainDashboard/CurrentTotal.vue